// extracted by extract-css-chunks-webpack-plugin
module.exports = {"registryDiscountPrice":"price-display__registryDiscountPrice__sHBGL"};